import { render } from "./hotelRevenues.vue?vue&type=template&id=0b9ef6ec&scoped=true"
import script from "./hotelRevenues.vue?vue&type=script&lang=js"
export * from "./hotelRevenues.vue?vue&type=script&lang=js"

import "./hotelRevenues.vue?vue&type=style&index=0&id=0b9ef6ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9ef6ec"]])

export default __exports__